export default [
  {
    path: '/pcs/outsite/dt',
    name: 'DigitalTwin',
    meta: {
      pageTitle: 'Digital Twin',
      title: 'Digital Twin',
      authRequired: true,
    },
    component: () => import('../../views/linkout/digitaltwin'),
  },
  {
    path: '/pcs/outsite/rtls',
    name: 'RTLS',
    meta: {
      pageTitle: 'RTLS',
      title: 'RTLS',
      authRequired: true,
    },
    component: () => import('../../views/linkout/rtls'),
  },
]
